import { CoreModel } from '../core/core.model';
import { ButtonModel } from '../button/button.model';
export class FabButtonModel extends CoreModel {
/**
 * ButtonModel for the button (trigger or mini fab action).
 */
button?: ButtonModel;
/**
 * Position of the button tooltip. Can be: above, below, left, right.
 */
tooltipPosition?: string;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function FabButtonModel_tsickle_Closure_declarations() {
/**
 * ButtonModel for the button (trigger or mini fab action).
 * @type {?}
 */
FabButtonModel.prototype.button;
/**
 * Position of the button tooltip. Can be: above, below, left, right.
 * @type {?}
 */
FabButtonModel.prototype.tooltipPosition;
}

